export default {"src":"/_next/static/media/no-result.89b22c57.svg","height":244,"width":300,"blurWidth":0,"blurHeight":0};